import type { IsoYearAndMonth } from '../../types/iso-date';

/**
 * Checks whether the given string is a valid ISO year-month in YYYY-MM format.
 * Returns true with a branded type guard on success, false otherwise.
 */
export function isIsoYearAndMonth(str: string): str is IsoYearAndMonth {
  return /^\d{4}-(0[1-9]|1[0-2])$/.test(str);
}
